import { render, staticRenderFns } from "./BatchOrderFinalDelivery.vue?vue&type=template&id=f25eb77c&scoped=true&"
import script from "./BatchOrderFinalDelivery.vue?vue&type=script&lang=js&"
export * from "./BatchOrderFinalDelivery.vue?vue&type=script&lang=js&"
import style0 from "./BatchOrderFinalDelivery.vue?vue&type=style&index=0&id=f25eb77c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25eb77c",
  null
  
)

export default component.exports